<template>
  <header class="flex justify-between items-center flex-shrink-0 flex-grow-0 pr-3 pl-3 h-12" :class="[isCitizenM ? 'bg-black citizen-m' : 'bg-white']">
    <router-link to="/" class="block p-3 text-lg text-gray-500 flex items-center font-bold" data-test="home-link">
      <template v-if="isCitizenM">
        <img src="/img/anotherStar.png"  alt="anotherStar">
      </template>
      <template v-else>
        <img srcset="/img/coretix@2x.png 2x" src="/img/coretix.png" class="mr-3" alt="Coretix">
        Coretix
      </template>
    </router-link>
    <div v-if="alertMessage" class="bg-warning-100 border-4 border-warning-200 rounded-xl pl-6 pr-6">
      <i class="el-icon-warning"></i>
      {{ alertMessage }}
    </div>
    <div class="h-full flex items-center">
      <CustomerSwitch v-if="($route.name !== 'customers' && hasMultipleCustomers)" class="mr-3" />
      <ActionsDropdown />
    </div>
  </header>
</template>

<script>
import CustomerSwitch from '@/components/header/CustomerSwitch'
import ActionsDropdown from '@/components/header/ActionsDropdown.vue'
import { CUSTOMER_IDS } from '@/constants'

export default {
  name: 'TheHeader',
  components: { CustomerSwitch, ActionsDropdown },
  computed: {
    hasMultipleCustomers () {
      return this.$store.getters['customers/list'].length > 1
    },
    isCitizenM () {
      return this.$store.getters['customers/customer'] && (this.$store.getters['customers/customer'].ID === CUSTOMER_IDS.CITIZENM)
    },
    alertMessage () {
      return this.$store.getters['app/alertMessage']
    }
  },
  methods: {
    logoutFromKeycloak () {
      const keycloak = this.$keycloak
      if (keycloak && keycloak.authenticated) {
        keycloak.logout({ redirectUri: window.location.origin + '/logout', id_token_hint: keycloak.idToken })
      } else {
        this.$router.push({ name: 'logout' })
      }
    }
  }
}
</script>
